import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../support/with_presenter';
import {DestroyButtonPresenter} from './destroy_button_presenter';
import {SprintDeleter} from '../../business/sprint_deleter';

interface OwnProps {}

const DestroyButtonComponent: FunctionComponent<OwnProps & PresenterProps<DestroyButtonPresenter>> = observer(
    ({presenter}) => {
        return (
            <button
                className="btn btn-inline btn-tertiary ion-trash-b"
                onDrop={() => presenter.handleDrop()}
                onDragOver={(event) => presenter.handleDragOver(event)}
                onClick={() => presenter.handleOnClick()}
            />
        );
    },
);

export const DestroyButton = withPresenter<DestroyButtonPresenter, OwnProps>(
    (props, component) =>
        new DestroyButtonPresenter(
            component.dragContext,
            new SprintDeleter(component.sprintsRepository, component.sprintApi),
            component.sprintSelectionManager,
        ),
    DestroyButtonComponent,
);
